var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"litops orangeToYellow com_top"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v(_vm._s(_vm.no))])]),_c('div',{staticClass:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }